import React from 'react';

const BuilderCollectionContext = React.createContext();

export default BuilderCollectionContext;
